import {OwayoKonfiPart} from "./owayoPartWithSelObs";
import {SelectableObject} from "./selectableObjects";
import {StringDictionary, Vector2} from "./delme_globals";
import globalsObject from "./globalsObject";

type XY = {x:number, y:number};

export class SelObNewValueCalculatorafterProductChangeCalculator {
    private readonly modelParts: StringDictionary<OwayoKonfiPart>;

    constructor(modelParts: StringDictionary<OwayoKonfiPart>) {
        this.modelParts = modelParts;
    }

    public calculateNewSelObValuesOnNewParts(selOb: SelectableObject, oldPartDimensionsCm: Vector2) {

        const oldPartName = selOb.partName;

        if (typeof (this.modelParts[oldPartName]) === "undefined") {
            return this.getnewValuesForSelObOnNewParts(selOb, oldPartName, oldPartDimensionsCm);
        }
        const newPart = this.modelParts[oldPartName];
        if (globalsObject.owayoJSViewer.partIsDropTarget(newPart) === false) {
            return null;
        }
        //da das Seitenverhältnis sich geändert haben könnte, müssen wir die Größen anpassen
        return SelObNewValueCalculatorafterProductChangeCalculator.getValuesOnSelObAfterMovingToPartWithSameName(selOb, oldPartName, oldPartDimensionsCm, newPart);
    }

    private static getValuesOnSelObAfterMovingToPartWithSameName(selOb:SelectableObject, oldPartName: any, oldPartDimensionsCm:XY, newPart:OwayoKonfiPart) {
        switch (oldPartName) {
            case "FrontLeftPart" :
                //bei den Frontparts ist am ehesten die Breite unterschiedlich, hier gehe ich auf den Abstand zur Mitte
                return SelObNewValueCalculatorafterProductChangeCalculator.getValuesOfSelObOnNewFrontLeftPart(selOb, oldPartDimensionsCm, newPart);
            case "FrontRightPart" :
                return SelObNewValueCalculatorafterProductChangeCalculator.getNewValuesOfSelObOnNewFrontRightPart(selOb, oldPartDimensionsCm, newPart);
            case "LeftArm" :
            case "RightArm":
                //hier ist wahrscheinlich die Höhe des Parts unterschiedlich. Ich gehe auf den Abstand zum oberen Ende (y = 1)
                return SelObNewValueCalculatorafterProductChangeCalculator.getNewValuesOfSelObOnNewArm(selOb, oldPartName, oldPartDimensionsCm, newPart);
            default:
                return {partName: oldPartName, x: selOb.translation.x, y: selOb.translation.y};
        }
    }

    private static getNewValuesOfSelObOnNewArm(selOb:SelectableObject, oldPartName:string, oldPartDimensionsCm:XY, newPart:OwayoKonfiPart) {

        const valuesOnNewPart = {partName: oldPartName, x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.y) * oldPartDimensionsCm.y;
        if (abstandCm > newPart.partSizeCM.y) {
            return null;
        }
        valuesOnNewPart.y = 1 - (abstandCm / newPart.partSizeCM.y);
        return valuesOnNewPart;
    }

    private static getNewValuesOfSelObOnNewFrontRightPart(selOb:SelectableObject, oldPartDimensionsCm:XY, newPart:OwayoKonfiPart) {
        const valuesOnNewPart = {partName: "FrontRightPart", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.x) * oldPartDimensionsCm.x;
        if (abstandCm > newPart.partSizeCM.x) {
            return null;
        }
        valuesOnNewPart.x = 1 - (abstandCm / newPart.partSizeCM.x);
        return valuesOnNewPart;
    }

    private static getValuesOfSelObOnNewFrontLeftPart(selOb:SelectableObject, oldPartDimensionsCm:XY, newPart:OwayoKonfiPart) {
        const valuesOnNewPart = {partName: "FrontLeftPart", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = selOb.translation.x * oldPartDimensionsCm.x;
        if (abstandCm > newPart.partSizeCM.x) {
            return null;
        }
        valuesOnNewPart.x = abstandCm / newPart.partSizeCM.x;
        return valuesOnNewPart;
    }

    private getnewValuesForSelObOnNewParts(selOb: SelectableObject, oldPartName: string, oldPartDimensionsCm: XY) {
        switch (oldPartName) { //wir schauen, ob wir Logos auf andere Parts übertragen können... Das muss alles wahrscheinlich hier raus und irgendwo
            //zentral gespeichert werden
            case "Front" :
                return this.getNewSelObValuesAfterMovingFromFront(selOb, oldPartDimensionsCm);
            case "FrontLeftPart" :
                return this.getNewSelObValuesAfterMovingFromFrontLeftPart(selOb, oldPartDimensionsCm);
            case "FrontRightPart" :
                return this.getValuesOfSelObAfterMovingFromFrontRightPart(selOb, oldPartDimensionsCm);
            case "Back":
                return this.getNewSelObValuesAfterMovingFromBack(selOb, oldPartDimensionsCm);
            case "Back1":
                return this.getNewSelObValuesAfterMovingFromBack1(selOb, oldPartDimensionsCm);
            case "Back2":
                return this.getNewSelObValuesAfterMovingFromBack2(selOb, oldPartDimensionsCm);
            case "Bag":
                return this.getNewSelObValuesAfterMovingFromBag(selOb, oldPartDimensionsCm);
            default:
                return null;
        }
    }

    private getValuesOfSelObAfterMovingFromFrontRightPart(selOb: SelectableObject, oldPartDimensionsCm: XY) {
        const valuesOnNewPart = {partName: "Front", x: selOb.translation.x, y: selOb.translation.y};
        if (typeof (this.modelParts["Front"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Front"];
        const abstandCm = (1 - selOb.translation.x) * oldPartDimensionsCm.x - 1.5; // + 1.5cm für den RV
        if (abstandCm > 0.5 * newPart.partSizeCM.x) {
            return null;
        }
        valuesOnNewPart.x = 0.5 - abstandCm / newPart.partSizeCM.x;
        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromFrontLeftPart(selOb: SelectableObject, oldPartDimensionsCm: XY) {
        const valuesOnNewPart = {partName: "Front", x: selOb.translation.x, y: selOb.translation.y};

        if (typeof (this.modelParts["Front"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Front"];
        valuesOnNewPart.partName = "Front";
        const abstandCm = selOb.translation.x * oldPartDimensionsCm.x + 1.5;  // - 1.5cm für den RV
        if (abstandCm > 0.5 * newPart.partSizeCM.x) {
            return null;
        }
        valuesOnNewPart.x = 0.5 + abstandCm / newPart.partSizeCM.x;
        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromFront(selOb: SelectableObject, oldPartDimensionsCm: XY) {
        const valuesOnNewPart = {partName: "", x: selOb.translation.x, y: selOb.translation.y};


        if (typeof (this.modelParts["FrontLeftPart"]) === "undefined" || typeof (this.modelParts["FrontRightPart"]) === "undefined") {
            return null;
        }
        let abstandCm = (selOb.translation.x - 0.5) * oldPartDimensionsCm.x;
        let newPart:OwayoKonfiPart;
        if (abstandCm <= 0) {
            abstandCm -= 1.5; //RV Zugabe
            //d.h. wir gehen auf den FrontRightPart
            newPart = this.modelParts["FrontRightPart"];
            valuesOnNewPart.partName = "FrontRightPart";
            if (-abstandCm > newPart.partSizeCM.x) { //abstand ist negativ!
                return null;
            }
            valuesOnNewPart.x = 1 + (abstandCm / newPart.partSizeCM.x); //abstand ist negativ!!
        } else {
            abstandCm += 1.5; //RV Zugabe
            newPart = this.modelParts["FrontLeftPart"];
            valuesOnNewPart.partName = "FrontLeftPart";
            if (abstandCm > newPart.partSizeCM.x) {
                return null;
            }
            valuesOnNewPart.x = abstandCm / newPart.partSizeCM.x;
            // selOb.translation.x = abstandCm / newPart.partSizeCM.x;
        }

        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromBack1(selOb: SelectableObject, oldPartDimensionsCm: XY): { partName: string, x: number, y: number } | null {
        if (typeof (this.modelParts["Back"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Back"];
        const valuesOnNewPart = {partName: "Back", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.y) * oldPartDimensionsCm.y;
        if (abstandCm > newPart.partSizeCM.y) {
            return null;
        }
        valuesOnNewPart.y = 1 - (abstandCm / newPart.partSizeCM.y);
        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromBack(selOb: SelectableObject, oldPartDimensionsCm: XY): { partName: string, x: number, y: number } | null {
        if (typeof (this.modelParts["Back1"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Back1"];
        const valuesOnNewPart = {partName: "Back1", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.y) * oldPartDimensionsCm.y;
        if (abstandCm > newPart.partSizeCM.y) {
            return null;
        }
        valuesOnNewPart.y = 1 - (abstandCm / newPart.partSizeCM.y);
        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromBack2(selOb: SelectableObject, oldPartDimensionsCm:XY): { partName: string, x: number, y: number } | null {
        if (typeof (this.modelParts["Bag"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Bag"];
        const valuesOnNewPart = {partName: "Bag", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.y) * oldPartDimensionsCm.y;
        if (abstandCm > newPart.partSizeCM.y) {
            return null;
        }
        valuesOnNewPart.y = 1 - (abstandCm / newPart.partSizeCM.y);
        return valuesOnNewPart;
    }

    private getNewSelObValuesAfterMovingFromBag(selOb: SelectableObject, oldPartDimensionsCm: XY): { partName: string, x: number, y: number } | null {
        if (typeof (this.modelParts["Back2"]) === "undefined") {
            return null;
        }
        const newPart = this.modelParts["Back2"];
        const valuesOnNewPart = {partName: "Back2", x: selOb.translation.x, y: selOb.translation.y};
        const abstandCm = (1 - selOb.translation.y) * oldPartDimensionsCm.y;
        if (abstandCm > newPart.partSizeCM.y) {
            return null;
        }
        valuesOnNewPart.y = 1 - (abstandCm / newPart.partSizeCM.y);
        return valuesOnNewPart;
    }
}
